<ng-template #modalSuccessExport let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="d()" text="{{ '' | translate }}">
    <div class="d-flex" body>
      <div class="align-self-center">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-success.svg'"></span>
      </div>
      <div>
        <span [innerHtml]="'export_success1' | translate"></span>
        <span class="font-weight-bold">{{ user.profile.email }} </span>
        <span>{{ 'export_success2' | translate }}</span>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalExportError let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="d()" text="{{ '' | translate }}">
    <div class="d-flex" body>
      <div class="align-self-center">
        <span class="icon" [inlineSVG]="'assets/images/icons/icon-warning.svg'"></span>
      </div>
      <div>
        <span translate>reseller_history_export_interval_time</span>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalConfirmDelete let-c="close" let-d="dismiss">
  <wsb-modal title="{{ '' | translate }}" (dismiss)="d()" (primary)="close()" text="{{ '' | translate }}">
    <div body>
      <span>{{ 'common_success' | translate }}</span>
    </div>
  </wsb-modal>
</ng-template>
  <div class="my-3 mb-5">
    <wsb-atlas-grid
      #grid
      class="atlas-grid-simplest"
      class="mt-2"
      *ngIf="tableColumnsDefs && tableHistoryGridOptions"
      [exportFc]="fc"
      [loading]="tableLoading"
      [columnDefs]="tableColumnsDefs"
      [exportOnlyCampaign]="true"
      [checkboxDisable]="true"
      [options]="tableHistoryGridOptions"
      [components]="components"
      [@gridIsLoaded]="gridAnimationState"
    ></wsb-atlas-grid>
  </div>
